import React, { useState, useCallback } from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import withRouter from 'react-router-dom/withRouter'

import Breadcrumbs from '../../../../global/components/navigation/Breadcrumbs.js.jsx'

import AdminOnboardForm from '../components/AdminOnboardForm.js.jsx'
import AdminFirmLayout from '../components/AdminFirmLayout.js.jsx'

import * as firmActions from '../../firmActions'

const AdminCreateFirm = ({ location, history, dispatch }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [values, setValues] = useState({
    name: '',
    licenseCount: 1,
    contact_firstName: '',
    contact_lastName: '',
    contact_email: '',
    contact_phone: '',
  })

  const onChange = useCallback(
    e => {
      setValues(existing => ({
        ...existing,
        [e.target.name]: e.target.value,
      }))
    },
    [setValues],
  )

  const onSubmit = useCallback(
    e => {
      e.preventDefault()

      if (isLoading) {
        return
      }

      setIsLoading(true)
      dispatch(
        firmActions.sendOnboardFirm({
          name: values.name,
          createdBy: '',
          logoUrl: '',
          licenseCount: values.licenseCount,
          contact: {
            firstName: values.contact_firstName,
            lastName: values.contact_lastName,
            email: values.contact_email,
            phone: values.contact_phone,
          },
        }),
      ).then(resp => {
        setIsLoading(false)
        if (resp.success) {
          dispatch(firmActions.invalidateList())
          history.push(`/admin/firms/${resp.item._id}`)
        } else {
          alert('ERROR - Check logs')
        }
      })
    },
    [isLoading, setIsLoading, values, dispatch, history],
  )

  return (
    <AdminFirmLayout>
      <Helmet>
        <title>Admin Create Firm</title>
      </Helmet>
      <Breadcrumbs links={location.state.breadcrumbs} />
      <AdminOnboardForm
        cancelLink="/admin/firms"
        values={values}
        handleFormChange={onChange}
        handleFormSubmit={onSubmit}
        loading={isLoading}
      />
    </AdminFirmLayout>
  )
}

export default withRouter(connect()(AdminCreateFirm))
